import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./ShowPayment.module.css";

const API_BASE_URL = "https://coinyoco.world/brobizee-api";
const API_GET_PARTNER_URL = `${API_BASE_URL}/get_partner_money.php`;

export default function ShowPayment() {
  const navigate = useNavigate();
  const params = useParams();
  const userId = params?.userId || params?.userIdA || "";
  const uuid = params?.uuid || params?.deviceUuid || "";
  const [partnerMoney, setPartnerMoney] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const loadPartnerMoney = async () => {
      if (!userId && !uuid) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError("");
        const formData = new FormData();
        formData.append("secondary_id", String(userId));
        formData.append("secondary_uuid", String(uuid));
        const res = await fetch(API_GET_PARTNER_URL, { method: "POST", body: formData });
        if (!res.ok) throw new Error(`Request failed: ${res.status}`);
        const result = await res.json();
        console.log("PARTNER MONEY RESULT:", result);
        if (!cancelled && result?.success && result?.data) {
          const money = result.data.money;
          setPartnerMoney(money !== null && money !== undefined ? money : "00");
          try {
            if (money !== null && money !== undefined) localStorage.setItem("selected_sender_money", String(money));
            if (result.data.full_name) localStorage.setItem("selected_sender_name", result.data.full_name);
          } catch {}
        } else if (!cancelled) {
          setError(result?.message || "Unable to load amount");
        }
      } catch (err) {
        console.error("Partner money fetch error:", err);
        if (!cancelled) setError("Network error. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    loadPartnerMoney();
    return () => { cancelled = true; };
  }, [userId, uuid]);

  const handlePayment = () => navigate(userId && uuid ? `/${userId}/${uuid}/payment` : "/payment");
  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(userId && uuid ? `/${userId}/${uuid}/userhome` : "/");
  };
  const displayAmount = loading ? "..." : error ? "00" : partnerMoney ?? "00";

  return (
    <main className={styles.page}>
      <div className={styles.ambientGlow} aria-hidden="true" />
      <section className={styles.deviceFrame} aria-label="BroBizee payment summary">
        <header className={styles.topBar}>
          <button type="button" className={styles.backButton} onClick={handleBack} aria-label="Go back" title="Go back">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M19 12H5" /><path d="m12 19-7-7 7-7" />
            </svg>
          </button>
          <div className={styles.brandBlock}>
            <span className={styles.brandMark} aria-hidden="true">✓</span>
            <div><p className={styles.brandName}>BroBizee</p><p className={styles.brandCaption}>Secure payments</p></div>
          </div>
          <span className={styles.secureBadge}>⌑ Secure</span>
        </header>

        <div className={styles.content}>
          <div className={styles.eyebrow}><span className={styles.eyebrowDot} /> PAYMENT SUMMARY</div>
          <h1 className={styles.pageTitle}>Ready to pay?</h1>
          <p className={styles.pageSubtitle}>Review the amount before continuing to your payment.</p>

          <section className={styles.amountCard} aria-live="polite">
            <div className={styles.cardShine} aria-hidden="true" />
            <div className={styles.amountTopline}>
              <span className={styles.amountLabel}>Amount to Pay</span>
              <span className={styles.amountStatus}><span />{loading ? "Fetching" : error ? "Unavailable" : "Updated"}</span>
            </div>
            <div className={styles.amountRow}>
              <div className={styles.amountValueWrap}><span className={styles.currency}>₹</span><h2 className={styles.amountValue}>{displayAmount}</h2></div>
              <button type="button" className={styles.amountIcon} onClick={handlePayment} aria-label="Show Payment" title="Open Payment Page">
                <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="2" y="5" width="20" height="14" rx="3" /><path d="M2 10h20" /><path d="M6 15h3" />
                </svg>
              </button>
            </div>
            {error && <p className={styles.errorMessage} role="status">{error}</p>}
            <div className={styles.cardDivider} />
            <div className={styles.amountFooter}>
              <span className={styles.footerIcon}>✓</span><span>Protected with secure payment flow</span><span className={styles.footerSpacer} /><span className={styles.currencyCode}>INR</span>
            </div>
          </section>

          <div className={styles.trustRow}>
            <div className={styles.trustIcon}>✓</div>
            <div className={styles.trustCopy}><p className={styles.trustTitle}>Safe &amp; secure checkout</p><p className={styles.trustText}>Your payment details stay protected.</p></div>
            <span className={styles.trustChevron}>›</span>
          </div>

          <button type="button" className={styles.payButton} onClick={handlePayment} disabled={loading}>
            <span>{loading ? "Loading amount..." : "Continue to Payment"}</span>
            <span className={styles.payButtonArrow}>→</span>
          </button>
          <p className={styles.bottomNote}>⌑ You’ll review the payment on the next screen.</p>
        </div>

        <footer className={styles.bottomBrand}><span />On Time. Online. On Demand.<span /></footer>
      </section>
    </main>
  );
}